
import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

const HeroSection = () => {
  const { currentLanguage } = useLanguage();
  
  return (
    <section className="py-24 relative overflow-hidden">
      {/* Video background */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 w-full h-full overflow-hidden">
          <iframe 
            allow="fullscreen;autoplay" 
            allowFullScreen 
            src="https://streamable.com/e/jvq6sq?autoplay=1&nocontrols=1&loop=1" 
            width="100%" 
            height="100%" 
            style={{
              border: "none", 
              width: "100%", 
              height: "100%", 
              position: "absolute", 
              left: "0px", 
              top: "0px", 
              overflow: "hidden",
              pointerEvents: "none",
              objectFit: "cover"
            }}
            title="Why Future Level Background Video"
          ></iframe>
        </div>
        
        {/* Overlay for better content readability */}
        <div className="absolute inset-0 bg-black/60 backdrop-blur-[2px] z-0"></div>
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 font-future text-white micro-glitch">
            Warum Future Level?
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-10 max-w-3xl mx-auto">
            Weil Sie nicht irgendein Video brauchen. Sondern eines, das verkauft.
          </p>
          
          <Link to={`/${currentLanguage}/kontakt`}>
            <Button className="bg-purple-700 hover:bg-purple-600 text-white px-8 py-6 rounded-lg text-lg font-medium transition-all duration-300 shadow-lg shadow-purple-800/30 hover:shadow-purple-700/40 hover:scale-105 relative group">
              Jetzt Kontakt aufnehmen
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              <div className="absolute inset-0 rounded-lg bg-gradient-to-r from-purple-600 to-purple-800 opacity-0 group-hover:opacity-30 blur-xl transition-opacity duration-300"></div>
            </Button>
          </Link>
          
          <div className="w-2 h-2 rounded-full bg-purple-500 mx-auto mt-16 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
